// src/IconChevronLeftLine.tsx
import { forwardRef } from "react";
import { jsx } from "react/jsx-runtime";
var Icon = ({
  size = 24,
  ...props
}, ref) => /* @__PURE__ */ jsx(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "data-seed-icon": "true",
    "data-seed-icon-version": "0.0.21",
    width: size,
    height: size,
    ref,
    ...props,
    children: /* @__PURE__ */ jsx("g", { children: /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M15.7241 2.76052C16.105 3.16043 16.0896 3.79341 15.6897 4.17431L7.45 12.0222L15.6896 19.8689C16.0896 20.2498 16.105 20.8827 15.7242 21.2827C15.3433 21.6826 14.7103 21.6981 14.3104 21.3172L5.31037 12.7464C5.11218 12.5576 5.00001 12.2959 5 12.0222C4.99999 11.7486 5.11215 11.4868 5.31032 11.2981L14.3103 2.72608C14.7102 2.34518 15.3432 2.3606 15.7241 2.76052Z",
        fill: "currentColor"
      }
    ) })
  }
);
var IconChevronLeftLine = forwardRef(Icon);
var IconChevronLeftLine_default = IconChevronLeftLine;
export {
  IconChevronLeftLine_default as default
};
